import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <h1>Bienvenue sur</h1>
      <div className="home-logos">
        <img src="/logo_round.svg" alt="" className="home-logo-round" />
        <img src="/logo.svg" alt="HAILP" className="home-logo" />
      </div>
      <p>La plateforme de prévention au harcèlement</p>
      <nav className="home-nav">
        <Link to="/login" className="home-link">Connexion</Link>
        <Link to="/register" className="home-link">Inscription</Link>
      </nav>
    </div>
  );
}

export default Home;
